// État d'une vue iCTI, commun a la page Usage des vues et a Configuration > Referentiels > Vues (BI-693).
// Colonne dédiée (pastille de couleur + mot court) plutôt que des badges en bout de libellé.
import React from "react";
import { Tooltip } from "antd";
import { WarningOutlined } from "@ant-design/icons";

export const TEXTE_NOM_INCOHERENT = "L'attribut name du XML diffère du nom de fichier";

export const ETATS = {
  active: { texte: "Active", couleur: "#1baf7a" },
  supprimee: { texte: "Supprimée", couleur: "#e34948", aide: "Supprimée du dépôt iCTI ; son historique reste visible" },
  hors: { texte: "Hors référentiel", couleur: "#b4b2a9", aide: "Remontée par un environnement mais absente du référentiel" },
  // Fonctionnalites liees a un environnement (Configuration > Referentiels > Fonctionnalites)
  configuree: { texte: "Clé configurée", couleur: "#1baf7a" },
  expiree: { texte: "Expirée", couleur: "#e34948", aide: "Date d'expiration dépassée" },
  sans_cle: { texte: "Sans clé", couleur: "#b4b2a9", aide: "Aucune clé configurée pour cet environnement" },
};

// Ordre de tri : actives, puis supprimées, puis hors référentiel
const RANG = { active: 0, supprimee: 1, hors: 2, configuree: 0, sans_cle: 1, expiree: 2 };

export function EtatVue({ etat, nameMismatch, declaredName }) {
  const e = ETATS[etat] || ETATS.active;
  const libelle = (
    <span data-testid="etat-vue" style={{ display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
      <span style={{ width: 8, height: 8, borderRadius: 4, background: e.couleur, flexShrink: 0 }} />
      {e.texte}
    </span>
  );
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      {e.aide ? <Tooltip title={e.aide}>{libelle}</Tooltip> : libelle}
      {nameMismatch && (
        <Tooltip title={declaredName ? `${TEXTE_NOM_INCOHERENT} (déclaré : ${declaredName})` : TEXTE_NOM_INCOHERENT}>
          <WarningOutlined data-testid="nom-incoherent" aria-label="nom incohérent" style={{ color: "#d46b08" }} />
        </Tooltip>
      )}
    </span>
  );
}

// Colonne « État » : etatDe(r) renvoie une cle de ETATS (active | supprimee | hors | configuree | expiree | sans_cle)
export const colonneEtat = (etatDe, declaredNameDe = () => undefined) => ({
  title: "État",
  key: "etat",
  width: 150,
  sorter: (a, b) => RANG[etatDe(a)] - RANG[etatDe(b)],
  sortDirections: ["ascend", "descend"],
  render: (_, r) => <EtatVue etat={etatDe(r)} nameMismatch={!!r.name_mismatch} declaredName={declaredNameDe(r)} />,
});
